import { render } from "./UserNoteModal.vue?vue&type=template&id=a01db6aa"
import script from "./UserNoteModal.vue?vue&type=script&lang=js"
export * from "./UserNoteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__